define('setup/setup-configurator',['require','setup/setup-store','setup/configurators/configurator-factory','lodash'],function (require) {
    var store = require('setup/setup-store');
    var factory = require('setup/configurators/configurator-factory');
    var _ = require('lodash');
    var configurator;
    var initializeingProm;

    return {
        isInitialize: false,

        preFetchWorkflowDependencies: function () {
            if (!configurator) {
                return;
            }

            // remove #setup/ or /setup/ from the next url to get the page name
            var cleanPageKey = function (key) { return key ? key.replace(/(\/|#)?setup\//, '') : key };
            var config = configurator.get();

            // try pre-fetching all pages in the workflow for the user....
            var calls = [];
            var pagesConfig = _.pick(config, function (value, key, obj) {
                return _.isObject(obj[key]) && _.has(obj[key], 'nextUrl');
            });

            // traverse the workflow from the initial page
            // jumping to the nextUrl page and prefetching nextUrl
            var cur = pagesConfig[cleanPageKey(config.initialPage)];
            while (cur) {
                if (cur.nextUrl) {
                    calls.push(store.prefetch(cur.nextUrl));
                }

                cur = pagesConfig[cleanPageKey(cur.nextUrl)];
            }

            /* eslint-disable consistent-return */
            return $.when(calls);
            /* eslint-enable */
        },

        initialize: function () {
            return store
                .fetch()
                .then(function (config) {
                    configurator = factory.getInstance(config);
                    this.isInitialize = true;
                    this.config = config;
                    this.preFetchWorkflowDependencies();
                }.bind(this));
        },

        update: function () {
            if (!this.isInitialize && initializeingProm) {
                return initializeingProm;
            }

            var deferredPromise = $.Deferred();

            store
                .update()
                .always(function () {
                    configurator.setCompleteUrl('#');
                    deferredPromise.resolve();
                });

            return deferredPromise.promise();
        },

        getSetupData: function () {
            if (!configurator) {
                throw new Error('setup configurator has not been initialized. Call initialize() first');
            }

            return configurator.get();
        }
    };
});

